import get from 'lodash.get';

import { emptyObject } from 'ui-components/default-props/empty';

const selectJobIdToFulfillmentSetIdMap = (state) => get(state, 'jobIdsToFpSetIdMap', emptyObject);
export const selectFufillmentPlanSetIdByJobId = (state, props) => get(selectJobIdToFulfillmentSetIdMap(state), props.jobId);
export const selectFulfillmentPlanSetIdDerivedData = (state, props) => get(state, props.fulfillmentPlanSetId, emptyObject);
export const selectShipDate = (state) => get(state, 'shipDate');
export const selectLabelBatchStatusModalId = (state) => get(state, 'lbsModalId', '');
export const selectBatchIdsByParentBatchId = (state, props) => {
  const allBatchIds = selectJobIdToFulfillmentSetIdMap(state);
  const batchIdsFiltered = Object.entries(allBatchIds).filter((entry) => entry[1] === props.batchId);
  return batchIdsFiltered.map((entry) => entry[0]);
};
